import React from 'react';
import { getThemeColors } from '../../../lib/theme';
import { parseDate } from './helpers';
import type { TimelineBar } from './types';
import { formatDate } from '../../../lib/dateFormat';

interface Props {
  bar: TimelineBar;
  dark: boolean;
  onClick?: () => void;
}

export function TimelineBarView({ bar, dark, onClick }: Props) {
  const tc = getThemeColors(dark);
  const color =
    bar.care.status === 2 ? '#12b76a'
    : bar.care.status === 3 ? '#f79009'
    : bar.care.status === 0 ? '#2e90fa'
    : bar.care.status === 1 ? '#98a2b3'
    : '#667085';
  const top = 44 + bar.row * 30;
  const fmtD = (v: unknown) => {
    if (!v) return '—';
    const d = parseDate(v);
    if (!d) return String(v);
    return formatDate(d); // Tooltip: volles Datum
  };
  return (
    <div
      title={`${bar.statusLabel}: ${bar.label} · ${fmtD(bar.care.startdatum)} – ${fmtD(bar.care.enddatum)}`}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
      style={{
        position: 'absolute', left: `${bar.left}%`, width: `${bar.width}%`, top, height: 20,
        minWidth: 22, borderRadius: 999, background: color, color: '#fff',
        boxShadow: dark ? 'none' : '0 8px 18px rgba(16,24,40,0.13)',
        display: 'flex', alignItems: 'center', padding: '0 9px', overflow: 'hidden',
        fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap', border: `1px solid ${tc.card}`,
        cursor: onClick ? 'pointer' : 'default', zIndex: 1,
        textDecoration: bar.care.status === 1 ? 'line-through' : 'none',
        opacity: bar.care.status === 1 ? 0.78 : 1,
      }}
    >
      {bar.width > 10 ? bar.label : ''}
    </div>
  );
}
